<template>
  <b-dropdown
    ref="dropdown"
    class="admin-select"
    toggle-class="admin-select__toggle"
    menu-class="admin-select__menu"
    variant="link"
    no-caret
    right
    :toggle-attrs="{ 'aria-label': label + ': ' + selectedLabel }"
  >
    <template #button-content>
      <span>{{ prefix }}{{ selectedLabel }}</span>
      <svg class="admin-select__caret" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m4 6 4 4 4-4" /></svg>
    </template>
    <li v-for="option in options" :key="option.value" role="presentation">
      <button
        type="button"
        class="dropdown-item"
        :class="{ active: option.value === value }"
        role="menuitemradio"
        :aria-checked="option.value === value ? 'true' : 'false'"
        @click="select(option.value)"
      >
        <span>{{ option.label }}</span>
        <span class="admin-select__check icon icon-check" :class="{ selected: option.value === value }" aria-hidden="true"></span>
      </button>
    </li>
  </b-dropdown>
</template>

<script>
export default {
  name: 'AdminSelect',
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true },
    label: { type: String, required: true },
    prefix: { type: String, default: '' },
  },
  computed: {
    selectedLabel(){
      const option = this.options.find(option => option.value === this.value)
      return option ? option.label : ''
    },
  },
  methods: {
    select(value){
      this.$refs.dropdown.hide(true)
      if(value === this.value) return
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>

<style scoped>
.admin-select { position: relative; max-width: 100%; }
.admin-select.show { z-index: 5000; }
.admin-select >>> .admin-select__toggle::after { display: none; }
.admin-select >>> .admin-select__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 31px;
  padding: 5px 9px;
  border: 1px solid rgba(67, 72, 87, 0.95);
  border-radius: 6px;
  background: rgba(10, 13, 20, 0.56);
  color: #cfd2da;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  text-decoration: none;
  box-shadow: none;
}
.admin-select.show >>> .admin-select__toggle,
.admin-select >>> .admin-select__toggle:hover,
.admin-select >>> .admin-select__toggle:focus-visible {
  border-color: #1997c6;
  color: #eaf7fc;
  box-shadow: 0 0 0 2px rgba(25, 151, 198, 0.12);
}
.admin-select__caret { width: 14px; height: 14px; flex-shrink: 0; color: #8f98aa; stroke: currentColor; stroke-width: 1.5; transition: transform 120ms ease; }
.admin-select.show .admin-select__caret { color: #7bccee; transform: rotate(180deg); }
.admin-select >>> .admin-select__menu {
  z-index: 5000;
  min-width: 100%;
  max-width: calc(100vw - 24px);
  margin-top: 5px;
  padding: 5px;
  border: 1px solid rgba(25, 151, 198, 0.48);
  border-radius: 7px;
  background: #0b111a;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
}
.admin-select >>> .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 32px;
  padding: 7px 9px;
  border-radius: 4px;
  background: transparent;
  color: #cfd2da;
  font-size: 12px;
  line-height: 1.4;
}
.admin-select >>> .dropdown-item:hover,
.admin-select >>> .dropdown-item:focus { background: rgba(25, 151, 198, 0.12); color: #eaf7fc; }
.admin-select >>> .dropdown-item.active { background: rgba(25, 151, 198, 0.2); color: #7bccee; }
.admin-select__check { visibility: hidden; font-size: 12px; }
.admin-select__check.selected { visibility: visible; }
</style>
